export default __webpack_public_path__ + "static/media/icon10.05542688.svg";